import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { yelp, facebook, instagram, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column center>
          <CFView h3 futura bold color="#EF1412" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center white bold>
            <CFLink href="https://www.facebook.com/pages/category/Sushi-Restaurant/Sushi-Modo-115886992366892/">
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="Sushi Modo Facebook"
              />
            </CFLink>
            <CFLink href="https://www.yelp.ca/biz/sushi-modo-burnaby-3">
              <CFImage w="45px" pr="10px" src={yelp} alt="Sushi Modo Yelp" />
            </CFLink>
            <CFLink href="https://www.zomato.com/vancouver/sushi-modo-cariboo-lougheed-burnaby">
              <CFImage
                w="45px"
                pr="10px"
                src={zomato}
                alt="Sushi Modo Zomato"
              />
            </CFLink>
            <CFLink href="https://www.instagram.com/sushimodo/">
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Sushi Modo Instagram"
              />
            </CFLink>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#EF1412" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter white bold>
            <CFLink href="https://www.facebook.com/pages/category/Sushi-Restaurant/Sushi-Modo-115886992366892/">
              <CFImage
                w="40px"
                pr="10px"
                src={facebook}
                alt="Sushi Modo Facebook"
                hover
              />
            </CFLink>
            <CFLink href="https://www.yelp.ca/biz/sushi-modo-burnaby-3">
              <CFImage
                w="40px"
                pr="10px"
                src={yelp}
                alt="Sushi Modo Yelp"
                hover
              />
            </CFLink>
            <CFLink href="https://www.zomato.com/vancouver/sushi-modo-cariboo-lougheed-burnaby">
              <CFImage
                w="40px"
                pr="10px"
                src={zomato}
                alt="Sushi Modo Zomato"
                hover
              />
            </CFLink>
            <CFLink href="https://www.instagram.com/sushimodo/">
              <CFImage
                w="40px"
                pr="10px"
                src={instagram}
                alt="Sushi Modo Instagram"
                hover
              />
            </CFLink>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
